import { render, staticRenderFns } from "./PAPostMap.vue?vue&type=template&id=6e10260a&"
import script from "./PAPostMap.vue?vue&type=script&lang=js&"
export * from "./PAPostMap.vue?vue&type=script&lang=js&"
import style0 from "./PAPostMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAPostMap.vue"
export default component.exports